import { createSlice } from '@reduxjs/toolkit';

const clickupConnectionSlice = createSlice({
  name: 'clickupConnection',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    addClickupConnection: (state, action) => {
      state.data = { ...state.data, ...action.payload };
      state.loading = true;
    },
    removeClickupConnection: (state) => {
      state.data = {};
      state.loading = false;
    },
  },
});

export const { addClickupConnection, removeClickupConnection } = clickupConnectionSlice.actions;
export default clickupConnectionSlice.reducer;
